import React, { useEffect, useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  Button,
  Card,
  Select,
  MenuItem,
  Tooltip,
  InputLabel,
  TextField,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  Grid,
} from "@mui/material";
import { Box, Stack } from "@mui/system";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import * as yup from "yup";
import SnackBarUI from "../../common/SnackUI";
import { DevTool } from "@hookform/devtools";
import AppbarUI from "../../common/AppbarUI";
import BodyWapperUI from "../../common/BodyWapperUI";
import DrawerUI from "../../common/DrawerUI";
import { testPostbackAction } from "../../redux/toolkit/postback/testPostback";
import { appListAction } from "../../redux/toolkit/apps/list";
import { IconButton } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { Helmet } from "react-helmet";
import LabelText from "../../common/LabelText";

const app_schema = yup
  .object()
  .shape({
    postbck_url: yup.string().required("Test PostBack  Url is required."),
    offer_id: yup.string().required("Offer id is required."),
    user_id: yup.string().required("User id Name is required."),
    trans_id: yup.string().required("transaction id Name is required."),
    bonus_amount: yup
      .number()
      .typeError("User Must Be a number.")
      .required("Bonus Amount is required."),
  })
  .required();

const TestPostback = () => {
  const [snakbar, setSnakbar] = useState(false);
  const [publisherPayout, setPublisherPayout] = useState("");
  const [userPayout, setUserPayout] = useState("");
  const { data: appData } = useSelector((state) => state.appLists);

  const {
    register,
    control,
    setError,
    watch,
    handleSubmit,
    formState: { errors },
    reset,
    getValues,
    setValue,
  } = useForm({
    resolver: yupResolver(app_schema),
    defaultValues: {},
  });

  const dispatch = useDispatch();

  const { data, status, message } = useSelector((state) => state.testPostback);

  const handleAppSubmit = async (data) => {
    data.user_payout = Number(userPayout);
    data.publisher_payout = Number(publisherPayout);
    const testPostbackData = await dispatch(testPostbackAction({ ...data }));
    setSnakbar(true);
  };

  const [selectedApp, setSelectedApp] = useState("select");
  const handleChange = (event) => {
    setSelectedApp(event.target.value);
  };

  useEffect(() => {
    let defaultValues = {};
    defaultValues.postbck_url = selectedApp?.postback_url;
    defaultValues.app_id = selectedApp?._id;
    reset({ ...defaultValues });
  }, [selectedApp]);

  const handleAmountUsdChange = (event) => {
    const value = event.target.value;
    if (value && !isNaN(value)) {
      setPublisherPayout(value);
      const calculatedUserPayout =
        (value * selectedApp?.user_commission || 0) / 100;
      setUserPayout(calculatedUserPayout.toFixed(4));
    } else {
      setPublisherPayout("");
      setUserPayout("");
    }
  };

  useEffect(() => {
    dispatch(appListAction({ is_deleted: false }));
  }, []);

  return (
    <>
      <Helmet>
        <title> Real Opinion Publisher | Test Post </title>
      </Helmet>

      <AppbarUI />
      <DrawerUI />
      <BodyWapperUI>
        <Card elevation={0} sx={{ p:{xs:2,md:5 , md:5}, border: "1px solid #000" }}>
          <Typography fontWeight={600} variant="h5" sx={{ mb: 5 }}>
            Test Postback
          </Typography>

          <form onSubmit={handleSubmit(handleAppSubmit)}>
            <Stack spacing={3}>
              <Stack>
                <Select
                  size="small"
                  value={selectedApp || ""}
                  displayEmpty
                  onChange={handleChange}
                  id="select"
                >
                  <MenuItem value="">Select App</MenuItem>
                  {appData?.map((item, i) => (
                    <MenuItem key={i} value={item}>
                      {item.app_name}
                    </MenuItem>
                  ))}
                </Select>
              </Stack>

              <Box sx={{ width: "100%" }}>
                <LabelText text="Test PostBack Url" />
                <TextField
                  inputProps={{ readOnly: true }}
                  InputLabelProps={{ shrink: true }}
                  type="text"
                  size="small"
                  fullWidth
                  {...register("postbck_url")}
                  error={!!errors?.postbck_url?.message}
                  helperText={errors?.postbck_url?.message}
                />
              </Box>

              <Typography variant="h6" fontWeight={600}>
                Body Data
              </Typography>

              {/* Header */}
              <Stack direction="row" spacing={2} sx={{ width: "100%" }}>
                <Typography
                  variant="h6"
                  sx={{ width: "50%", textAlign: "left" }}
                >
                  Key
                </Typography>
                <Typography
                  variant="h6"
                  sx={{ width: "50%", textAlign: "center" }}
                >
                  Value
                </Typography>
              </Stack>

              {/* Dynamic Row Generator (Repeated layout) */}
              {[
                {
                  label: "publisher_payout",
                  tooltip: "Enter the amount in USD...",
                  value: publisherPayout,
                  onChange: handleAmountUsdChange,
                  name: null,
                  type: "number",
                },
                {
                  label: "user_id",
                  tooltip: "Find user id in user list",
                  registerKey: "user_id",
                },
                {
                  label: "user_payout",
                  tooltip: "This is the reward given",
                  value: userPayout,
                  disabled: true,
                },
                {
                  label: "survey id",
                  tooltip: "survey id is always string",
                  registerKey: "offer_id",
                },
                {
                  label: "trans_id",
                  tooltip: "trans_id is always string",
                  registerKey: "trans_id",
                },
                {
                  label: "bonus_amount",
                  tooltip: "Amount given as bonus",
                  registerKey: "bonus_amount",
                },
              ].map((field, idx) => (
                <Stack
                  key={idx}
                  direction={{ xs: "column", sm: "row" }}
                  
                  spacing={2}
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <Stack
                    direction="row"
                    alignItems="center"
                    spacing={1}
                    sx={{ width: { xs: "100%", sm: "50%" } }}
                  >
                    <Typography sx={{ width: "150px" ,  }}>
                      {field.label}
                    </Typography>
                    <Tooltip title={field.tooltip} arrow>
                      <IconButton size="small">
                        <InfoIcon />
                      </IconButton>
                    </Tooltip>
                  </Stack>

                  {field.registerKey ? (
                    <TextField
                      fullWidth
                      size="small"
                      placeholder={field.label}
                      {...register(field.registerKey)}
                      error={!!errors?.[field.registerKey]?.message}
                      helperText={errors?.[field.registerKey]?.message}
                      sx={{ width: { xs: "100%", sm: "50%" } }}
                    />
                  ) : (
                    <TextField
                      fullWidth
                      size="small"
                      placeholder={field.label}
                      value={field.value}
                      onChange={field.onChange}
                      type={field.type || "text"}
                      disabled={field.disabled}
                      sx={{ width: { xs: "100%", sm: "50%" } }}
                    />
                  )}
                </Stack>
              ))}

              {/* Status */}
              <Stack
                direction={{ xs: "column", sm: "row" }}
                spacing={2}
                justifyContent="space-between"
                alignItems="center"
              >
                <Stack
                  direction="row"
                  alignItems="center"
                  spacing={1}
                  sx={{ width: { xs: "100%", sm: "50%" } }}
                >
                  <Typography sx={{ width: "150px" }}>status</Typography>
                  <Tooltip title="Select The Status" arrow>
                    <IconButton size="small">
                      <InfoIcon />
                    </IconButton>
                  </Tooltip>
                </Stack>

                <RadioGroup
                  row
                  sx={{
                    width: { xs: "100%", sm: "50%" },
                    justifyContent: { xs: "start", sm: "center" },
                  }}
                >
                  <FormControlLabel
                    {...register("status")}
                    value="true"
                    control={<Radio />}
                    label="True"
                  />
                  <FormControlLabel
                    {...register("status")}
                    value="false"
                    control={<Radio />}
                    label="False"
                  />
                </RadioGroup>
              </Stack>

              {/* Submit */}
              <Stack direction="row" justifyContent="center" sx={{ mt: 3 }}>
                <Button
                  type="submit"
                  variant="contained"
                  sx={{
                    paddingInline: "40px",
                    width: { xs: "100%", sm: "auto" },
                    // background:
                    //   "linear-gradient(177.64deg, #FFB100 10.65%, #FE299F 275.27%)",
                    background:"#000",
                    '&:hover':{
                      background:"#000"
                    },
                    textTransform: "none",
                  }}
                >
                  Submit
                </Button>
              </Stack>
            </Stack>
          </form>
        </Card>
      </BodyWapperUI>
      {snakbar && (
        <SnackBarUI
          state={snakbar}
          setState={setSnakbar}
          status={status}
          message={message}
        />
      )}
      <DevTool control={control} />
    </>
  );
};

export default TestPostback;
